module.exports = __webpack_public_path__ + "static/media/generic-ov.c21721c3.jpeg";